import { Box, Button, H4 } from '../widgets'
import { Submit } from '../forms'
import './SettingsLayout.scss'
import { SettingsBackButton } from './SettingsBackButton.jsx'

export const SettingsLayout = ({ title, buttonType, buttonText = 'Next', disabledButton, onClick, backButtonMobileOnly, onBackButtonClick,
 children, fullWidth, hideScrollBarGutters, ...props }) => (
  <Box column container fullWidth fullHeight alignItems="center">
    <Box className="settings-header" fullWidth={fullWidth} justifyContent="center" container>
      {onBackButtonClick && <SettingsBackButton mobileOnly={backButtonMobileOnly} onClick={onBackButtonClick} />}
      <H4 color="black">{title}</H4>
    </Box>
    <Box
      className="layout-container black-scroller"
      container
      fullWidth
      justifyContent="center"
      style={{ scrollbarGutter: hideScrollBarGutters ? 'none' : 'stable both-edges' }}
    >
      <Box className="content-container" fullWidth={fullWidth} column container {...props}>
        {children}
      </Box>
    </Box>
    {buttonType && <Box className="button-layout" fullWidth={fullWidth}>
      {buttonType === 'submit' && <Submit fullWidth>Save</Submit>}
      {buttonType === 'next' && <Button onClick={onClick} fullWidth p={16} disabled={disabledButton}>{buttonText}</Button>}
    </Box>}
  </Box>
)